import type { DashboardSummaryDto, TopWineDto } from './dto/models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { DashboardPeriod } from '../enums/dashboard-period.enum';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  apiName = 'Default';
  

  getDashboardSummary = (period: DashboardPeriod = 1, config?: Partial<Rest.Config>) =>
    this.restService.request<any, DashboardSummaryDto>({
      method: 'GET',
      url: '/api/app/dashboard/dashboard-summary',
      params: { period },
    },
    { apiName: this.apiName,...config });
  

  getTopWines = (period: DashboardPeriod = 1, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TopWineDto[]>({
      method: 'GET',
      url: '/api/app/dashboard/top-wines',
      params: { period },
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
